export default {
  common: {
    home: '首頁',
    models: '型號列表',
    agentBrands: '代理品牌',
    dealerBrands: '經銷品牌',
    contact: '聯繫我們',
    nisshinbo: 'Nisshinbo',
    feihong: '飛虹',
    ketianshi: '可天士',
    more: '查看更多',
    readMore: '閱讀更多',
    viewDetails: '查看詳情',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '篩選',
    category: '分類',
    region: '地區',
    company: '公司',
    name: '姓名',
    phone: '電話',
    email: '郵箱',
    message: '留言',
    subject: '主題',
    address: '地址',
    workingHours: '工作時間',
    confirm: '確定',
    menu: '選單'
  },
  home: {
    latestNews: '最新動態',
    aboutUs: '關於我們',
    techFuture: '科技引領未來',
    innovation: '創新驅動發展',
    introduce: '金矽科技（香港）有限公司（Kam Zi Technology (HK) Company Ltd）是一間扎根香港的電子零件代理及貿易公司，為日清紡微電子（Nisshinbo Micro Devices）、可天士（KODENSHI AUK）及飛虹（FeiHong）等知名品牌的香港官方代理，並同時經銷多個國際及本地品牌的電子元件產品。',
    bizTitle: '公司代理品牌覆蓋產品類型廣泛，包括：',
    biz1: '類比半導體與微波元件',
    biz2: '功率半導體（IGBT、MOSFET、三極管）',
    biz3: '電源管理IC（LDO、DC/DC轉換器、PMIC）',
    biz4: '音頻處理IC與音量控制IC',
    biz5: '光電元件（光電二極管、光電三極管、光電開關、編碼器）',
    biz6: '感測器模組與模擬前端（AFE）',
    biz7: '電池管理與保護IC',
    biz8: '工業與汽車專用ASIC/ASSP',
    introduce2: '憑藉豐富多元的產品線、一站式採購服務、靈活庫存管理、完善物流配送及專業技術支援，我們能快速回應客戶需求並保障關鍵項目供貨穩定。'
  },
  searchPage: {
    title: '產品搜索',
    subtitle: '輸入型號名稱將在所有產品數據中查找。',
    browseModels: '瀏覽完整型號列表',
    hintBeforeSearch: '在上方輸入關鍵詞後，點擊「搜索」查看匹配的型號列表。',
    emptyAfterSearch: '未找到符合條件的型號，請嘗試其它關鍵詞或瀏覽完整型號列表。',
    emptySearchWarning: '請先輸入型號名稱再搜索。',
    productModelColumn: '產品型號',
    datasheetDownloadColumn: '產品規格書下載',
    resultCount: '共 {count} 條數據'
  },
  models: {
    clickToDownload: '點擊下載',
    categoryName: '分類名稱',
    feihongCatTransistor: '晶體管',
    feihongCatIgbt: 'IGBT',
    feihongCatPlaneMosfet: '平面 MOSFET',
    feihongCatSuperJunctionMosfet: '超級結 MOSFET',
    feihongCatTrenchMosfet: '溝槽 MOSFET',
    feihongProducts: '產品列表',
    feihongOfficialSite: '訪問飛虹官網',
    feihongProductListDesc: '以下為飛虹產品型號列表，僅支援按產品型號與分類篩選。',
    feihongModelPlaceholder: '請輸入產品型號',
    ketianshiProducts: '產品列表',
    ketianshiProductListDesc: '以下為可天士產品型號列表，僅支援按產品型號與分類篩選。',
    ketianshiModelPlaceholder: '請輸入產品型號',
    kodenshiTopCategory: '頂級分類',
    kodenshiCategoryPath: '分類路徑',
    kodenshiDetailUrl: '詳情連結',
    kodenshiSegSensor: '感測器',
    kodenshiCatDistanceSensor: '距離感測器',
    kodenshiCatDualLens: '雙透鏡',
    kodenshiCatSingleLens: '單透鏡',
    kodenshiCatPaperSensor: '紙張感測器',
    kodenshiCatIndustrialSensor: '工業感測器',
    kodenshiCatLaserDustSensor: '雷射粉塵感測器',
    kodenshiCatEncoderModule: '編碼器模組',
    kodenshiCatLightEmitting: '發光器件',
    kodenshiCatTransmissiveModule: '透過型模組',
    kodenshiCatParallelLight: '平行光光源',
    kodenshiCatSeparatedType: '分離型',
    kodenshiCatPhotodiodeArray: '光敏二極體陣列',
    kodenshiCatExcitationType: '激勵型',
    kodenshiCatIrLed: '紅外發光二極體',
    kodenshiCatPointLightSource: '點光源',
    searchPlaceholder: '請輸入型號名稱',
    categoryPlaceholder: '選擇分類',
    model: '型號',
    productName: '產品名稱',
    productVersion: '產品版本',
    datasheet: '數據手冊類型',
    features: '特性',
    inputType: '輸入類型',
    outputType: '輸出類型',
    circuitCount: '電路數量',
    supplyVoltageMin: '最小供電電壓(V)',
    supplyVoltageMax: '最大供電電壓(V)',
    supplyCurrentTyp: '典型供電電流(mA)',
    supplyCurrentMax: '最大供電電流(mA)',
    inputOffsetVoltageTyp: '典型輸入偏移電壓(mV)',
    inputOffsetVoltageMax: '最大輸入偏移電壓(mV)',
    propagationDelay: '傳播延遲(ns)',
    tempMin: '最低工作溫度(°C)',
    tempMax: '最高工作溫度(°C)',
    specs: '規格參數',
    price: '參考價格',
    operation: '操作',
    qualityGrade: '質量等級',
    supplyVoltage: '供電電壓(V)',
    workingTemp: '工作溫度(°C)',
    productDetail: '產品詳情',
    packageType: '封裝類型',
    powerType: '電源類型',
    railToRail: '軌到軌',
    plp: 'PLP',
    electricalCharacteristics: '電氣特性',
    supplyVoltageRange: '供電電壓範圍',
    typicalSupplyCurrent: '典型供電電流',
    maxSupplyCurrent: '最大供電電流',
    maxInputOffsetVoltage: '最大輸入偏移電壓',
    typicalInputBiasCurrent: '典型輸入偏置電流',
    typicalSlewRate: '典型壓擺率',
    typicalGainBandwidth: '典型增益帶寬',
    equivalentInputNoise: '等效輸入噪聲',
    outputCurrent: '輸出電流',
    temperatureCharacteristics: '溫度特性',
    workingTempRange: '工作溫度範圍',
    junctionTemp: '結溫',
    productFeatures: '產品特性',
    productSpecification: '產品規格書',
    disclaimer: '規格資料僅供參考，本公司並不對資料準確性負責',
    allCategories: '全部',
    consumer: '消費級',
    industrial: '工業級',
    automotive: '汽車級',
    military: '軍用級',
    amplifier: '運算放大器',
    amplifierDesc: '高性能運算放大器，適用於精密放大、信號調理等應用',
    comparator: '比較器',
    comparatorDesc: '高速比較器，適用於信號比較、閾值檢測等應用',
    special: '特殊功能放大器',
    specialDesc: '特殊功能放大器，包括儀表放大器、差分放大器等專用產品',
    sensorMonitoringAfe: '感測器監測模擬前端（AFE）',
    sensorMonitoringAfeDesc: '專用於感測器監測的模擬前端（AFE）產品系列，提供高精度數據採集解決方案',
    dataConverter: '數據轉換器',
    dataConverterDesc: '高性能數據轉換器產品系列，包括電壓頻率轉換器等多種轉換解決方案',
    ldoLinearRegulator: 'LDO線性穩壓器',
    ldoLinearRegulatorDesc: '低壓差線性穩壓器產品系列，提供穩定的電壓輸出和優異的線性調節性能',
    dcdcSwitchingRegulator: 'DC/DC開關穩壓器',
    dcdcSwitchingRegulatorDesc: '高效率DC/DC開關穩壓器產品系列，提供優異的電源轉換效率和穩定性能',
    pmics: '電源管理積體電路（PMIC）',
    pmicsDesc: 'PMIC 電源管理晶片產品系列，面向汽車與工業等應用，提供完整電源管理解決方案',
    ioLink: 'IO-Link設備收發器',
    ioLinkDesc: 'IO-Link設備收發器產品系列，為工業自動化應用提供可靠的通信解決方案',
    switchingDriversGate: '柵極驅動器',
    switchingDriversGateDesc: '柵極驅動器產品系列，為功率開關器件提供高效可靠的驅動解決方案',
    switchingDriversHalf: '半橋-全橋驅動器',
    switchingDriversHalfDesc: '半橋-全橋驅動器產品系列，為電機控制和功率轉換應用提供專業的驅動解決方案',
    switchingDriversWboost: '帶升壓轉換器的全橋驅動器',
    switchingDriversWboostDesc: '帶升壓轉換器的全橋驅動器產品系列，集成升壓功能，為低電壓應用提供高效的驅動解決方案',
    switchingICs: '開關 IC（Switch IC）',
    switchingICsDesc: '開關 IC 產品系列，涵蓋外接電源開關、過壓保護開關等多種開關類積體電路方案',
    shuntRegulators: '分流穩壓器（Shunt Regulator）',
    shuntRegulatorsDesc: '分流穩壓器產品系列，提供高精度基準與分流穩壓方案',
    chargePumps: '電荷泵（Charge Pump）',
    chargePumpsDesc: '電荷泵產品系列，提供負電壓轉換、倍壓轉換等方案',
    ssfmOscillator: '擴頻振盪器 IC（SSFM）',
    ssfmOscillatorDesc: 'SSFM 擴頻調變振盪器積體電路產品系列',
    ledController: 'LED 控制器',
    ledControllerDesc: 'LED 控制器產品系列，提供多通道 LED 驅動與控制方案',
    voltageDetector: '電壓檢測 IC',
    voltageDetectorDesc: '電壓檢測與復位類積體電路產品系列',
    resetTimer: '復位定時器',
    resetTimerDesc: '復位定時器產品系列，提供精確復位時序與延時功能',
    liIonBattery: '鋰離子電池保護',
    liIonBatteryDesc: '鋰離子電池保護與管理積體電路產品系列',
    batteryCharger: '電池充電器',
    batteryChargerDesc: '電池充電管理積體電路產品系列',
    batteryBackup: '電池備份 IC',
    batteryBackupDesc: '電池備份與電源管理積體電路產品系列',
    memsTransducer: 'MEMS 換能器',
    memsTransducerDesc: 'MEMS 感測器與換能器相關積體電路產品系列',
    memsMicrophoneAmplifiers: 'MEMS 麥克風放大器',
    memsMicrophoneAmplifiersDesc: 'MEMS 麥克風專用前置放大器產品系列',
    audioAmplifier: '音訊放大器',
    audioAmplifierDesc: '音訊放大器產品系列，提供高品質音訊放大方案',
    audioSignalProcessor: '音訊信號處理器',
    audioSignalProcessorDesc: '音訊信號處理與控制產品系列',
    audioSwitch: '音訊開關',
    audioSwitchDesc: '音訊信號切換與選擇開關產品系列',
    videoIC: '視訊 IC',
    videoICDesc: '視訊信號處理與控制積體電路產品系列',
    audioVideoMisc: '音視訊雜項',
    audioVideoMiscDesc: '音視訊雜項功能產品系列',
    rfSwitch: '射頻開關',
    rfSwitchDesc: '射頻信號開關與控制產品系列',
    categoryOthers: '其他',
    rfSwitchCategorySp3Sp4: 'SP3T/SP4T',
    rfSwitchCategorySp5Sp6: 'SP5T/SP6T',
    lowNoiseAmplifier: '低雜訊放大器',
    lowNoiseAmplifierDesc: '低雜訊放大器產品系列，適用於低雜訊信號放大應用',
    sawFilter: 'SAW 聲表濾波器',
    sawFilterDesc: '聲表面波（SAW）濾波器產品系列',
    fmIfDemodulator: 'FM 中頻解調 IC',
    fmIfDemodulatorDesc: 'FM 中頻解調積體電路產品系列',
    amplifierPLL: '放大器-鎖相環 IC',
    amplifierPLLDesc: '放大器與 PLL 組合積體電路產品系列',
    modulationDemodulationMixer: '調變解調混頻 IC',
    modulationDemodulationMixerDesc: '調變、解調與混頻器積體電路產品系列',
    stepperMotorDriver: '步進馬達驅動器',
    stepperMotorDriverDesc: '步進馬達驅動器產品系列',
    threePhaseBLDC: '三相無刷直流預驅動',
    threePhaseBLDCDesc: '三相無刷直流馬達預驅動器產品系列',
    singlePhaseBLDC: '單相/兩相單極無刷直流預驅動',
    singlePhaseBLDCDesc: '單相/兩相單極性無刷直流馬達預驅動器產品系列',
    actuatorGateDrivers: '執行器/柵極驅動器',
    actuatorGateDriversDesc: '執行器與柵極驅動器產品系列',
    realTimeClock: '實時時鐘（RTC）',
    realTimeClockDesc: '實時時鐘積體電路產品系列',
    quartzCrystalOscillator: '石英晶體振盪器 IC',
    quartzCrystalOscillatorDesc: '石英晶體振盪器積體電路產品系列',
    ateAssps: 'ATE 專用晶片（ASSP）',
    ateAsspsDesc: '自動測試設備（ATE）專用積體電路產品系列',
    lcdDrivers: 'LCD 驅動器',
    lcdDriversDesc: '液晶顯示（LCD）驅動器產品系列',
    ldDriverICs: '雷射二極體驅動 IC',
    ldDriverICsDesc: '雷射二極體（LD）驅動積體電路產品系列',
    analogSwitches: '模擬開關',
    analogSwitchesDesc: '模擬開關積體電路產品系列',
    ioPortExpansion: 'IO 埠擴展 IC',
    ioPortExpansionDesc: 'IO 埠擴展積體電路產品系列',
    otherPeripheralICs: '其他週邊 IC',
    otherPeripheralICsDesc: '其他週邊類積體電路產品系列',
    allModelsDesc: '所有型號產品，包括運算放大器、比較器、特殊功能放大器等',
    keyFeatures: '主要特性',
    func: '功能類型',
    voltageRange: '電壓範圍',
    note: '備註',
    datasheetType: '數據手冊類型',
    isNew: '是否新品',
    new: '新品',
    resolution: '分辨率',
    speed: '速度',
    interface: '接口',
    advantages: '優勢',
    currentConsumption: '電流消耗',
    maxCurrentConsumption: '最大電流消耗',
    pinCount: '引腳數',
    downloadDatasheet: '下載數據手冊',
    downloadSpec: '下載規格書',
    converterType: '轉換器類型',
    outputVoltage: '輸出電壓',
    inputVoltage: '輸入電壓',
    inputVoltageRange: '輸入電壓範圍',
    dropoutVoltage: '壓差電壓',
    quiescentCurrent: '靜態電流',
    lineRegulation: '線性調節率',
    loadRegulation: '負載調節率',
    outputNoise: '輸出噪聲',
    psrr: '電源抑制比',
    enableControl: '使能控制',
    thermalShutdown: '熱關斷',
    currentLimit: '電流限制',
    operatingTemp: '工作溫度',
    applications: '應用領域',
    switchingFrequency: '開關頻率',
    efficiency: '效率',
    standard: '標準級',
    grade: '等級',
    functionDesc: '功能描述',
    buckDcdc: '降壓 DC/DC（Buck）',
    ldoCount: 'LDO數量',
    vdCount: 'VD數量',
    wdtCount: 'WDT數量',
    gpioCount: 'GPIO數量',
    driveCircuit: '驅動電路',
    switchingCurrent: '開關電流',
    outputRiseTime: '輸出上升時間',
    outputFallTime: '輸出下降時間',
    fault: '故障檢測',
    protections: '保護功能',
    architecture: '架構',
    productUrl: '產品頁面',
    visitProductPage: '訪問產品頁面',
    outputPeakCurrent: '輸出峰值電流',
    switchingCurrentBoost: '升壓開關電流',
    referenceVoltage: '基準電壓',
    tolerance: '容差',
    cathodeCurrent: '陰極電流',
    dynamicImpedance: '動態阻抗',
    temperatureCoefficient: '溫度係數',
    frequency: '頻率',
    frequencyTolerance: '頻率容差',
    supplyCurrent: '供電電流',
    operatingVoltageRange: '工作電壓範圍',
    channelCount: '通道數',
    ledCurrent: 'LED電流',
    brightnessControl: '亮度控制',
    pwmSteps: 'PWM步數',
    detectionVoltage: '檢測電壓',
    detectionVoltageAccuracy: '檢測電壓精度',
    hysteresis: '遲滯',
    resetTimeout: '復位超時',
    operatingTemperature: '工作溫度',
    accuracy: '精度',
    outputDelayTime: '輸出延時時間',
    outputReleaseTime: '輸出釋放時間',
    overchargeVoltage: '過充電壓',
    overdischargeVoltage: '過放電壓',
    overcurrentDetection: '過流檢測',
    outputFunction: '輸出功能',
    operatingVoltage: '工作電壓',
    constantVoltage: '恆壓',
    constantCurrent: '恆流',
    linear: '線性',
    switching: '開關',
    normalOperation: '正常工作',
    backUpMode: '備份模式',
    lowDropout: '低壓差',
    voltageDetection: '電壓檢測',
    dualChannel: '雙通道',
    singleChannel: '單通道',
    biasVoltage: '偏置電壓',
    staticCapacitance: '靜態電容',
    chipSize: '芯片尺寸',
    audio: '音訊',
    video: '視訊',
    microphone: '麥克風',
    transducer: '傳感器',
    mems: 'MEMS',
    snr: '信噪比',
    maximumOutputVoltage: '最大輸出電壓',
    notes: '備註',
    preAmplifier: '前置放大器',
    lowPower: '低功耗',
    amplifierType: '放大器類型',
    control: '控制',
    channel: '通道',
    btl: 'BTL',
    outputPower: '輸出功率',
    voltageGain: '電壓增益',
    functions: '功能',
    powerAmplifier: '功率放大器',
    headphoneAmplifier: '耳機放大器',
    processorType: '處理器類型',
    volumeRange: '音量範圍',
    toneControl: '音調控制',
    inputSelector: '輸入選擇器',
    inputChannel: '輸入通道',
    outputChannel: '輸出通道',
    auxInput: '輔助輸入',
    auxOutput: '輔助輸出',
    licenseFeatures: '授權特性',
    electronicVolume: '電子音量',
    signalProcessor: '信號處理器',
    audioProcessor: '音頻處理器',
    dsp: 'DSP',
    input: '輸入',
    output: '輸出',
    inputOutput: '輸入/輸出',
    audioSelector: '音頻選擇器',
    stereo: '立體聲',
    mono: '單聲道',
    icCategory: 'IC分類',
    gain: '增益',
    driverSeventyFiveOhm: '75Ω驅動',
    lpfThOrder: 'LPF階數',
    inputChannels: '輸入通道',
    outputChannels: '輸出通道',
    videoAmplifier: '視頻放大器',
    videoSwitch: '視頻開關',
    videoFilter: '視頻濾波器',
    ecm: 'ECM',
    thd: 'THD',
    misc: '雜項',
    rf: 'RF',
    switch: '開關',
    highFrequency: '高頻',
    lowLoss: '低損耗',
    spdt: 'SPDT',
    sp4t: 'SP4T',
    spst: 'SPST',
    dpdt: 'DPDT',
    noiseFigure: '噪聲系數',
    iipThree: 'IIP3',
    operatingCurrent: '工作電流',
    packageSize: '封裝尺寸',
    poneDb: 'P1dB',
    frontEndModules: '前端模組',
    rfAmplifier: 'RF放大器',
    wideband: '寬帶',
    narrowband: '窄帶',
    centerFrequency: '中心頻率',
    passbandWidth: '通帶寬度',
    gps: 'GPS',
    glonass: 'GLONASS',
    galileo: 'Galileo',
    beidou: 'BeiDou',
    wifi: 'WiFi',
    bluetooth: 'Bluetooth',
    cellular: 'Cellular',
    productFunction: '產品功能',
    mixerFrequency: '混頻器頻率',
    fskComparator: 'FSK比較器',
    filterAmplifiers: '濾波放大器',
    quickCharge: '快速充電',
    rssi: 'RSSI',
    otherFeatures: '其他特性',
    wideBand: '寬帶',
    narrowBand: '窄帶',
    highPerformance: '高性能',
    referenceFrequency: '參考頻率',
    amplifierSupport: '放大器支持',
    pllSupport: 'PLL支持',
    mixerSupport: '混頻器支援',
    pll: 'PLL',
    mixer: '混頻器',
    modulationDemodulation: '調制解調',
    modulation: '調制',
    demodulation: '解調',
    fsk: 'FSK',
    waveShaping: '波形整形',
    driveMode: '驅動模式',
    inputMode: '輸入模式',
    motorCount: '電機數量',
    driverCategory: '驅動器分類',
    logicVoltage: '邏輯電壓',
    absoluteMaximumRating: '絕對最大額定值',
    outputModeFeature: '輸出模式特性',
    currentSelectFeature: '電流選擇特性',
    excitationModeFeature: '激勵模式特性',
    vrInputFeature: 'VR輸入特性',
    bipolar: '雙極性',
    unipolar: '單極性',
    pwm: 'PWM',
    clk: 'CLK',
    outputDriveMode: '輸出驅動模式',
    phaseInput: '相位輸入',
    leadAngle: '導通角',
    predriverCategory: '預驅動器分類',
    squareWave120: '120°方波',
    squareWave180: '180°方波',
    sineWave: '正弦波',
    singlePhase: '單相',
    twoPhase: '兩相',
    gateDriver: '門驅動器',
    actuator: '執行器',
    interfaceType: '接口類型',
    timeKeepingCurrent: '計時電流',
    timeKeepingVoltage: '計時電壓',
    timeKeepingVoltageRange: '計時電壓範圍',
    alarm: '鬧鐘',
    periodicalInterrupt: '週期中斷',
    clockOutput: '時鐘輸出',
    twoWire: '2線',
    threeWire: '3線',
    i2c: 'I2C',
    spi: 'SPI',
    oscillationFrequency: '振蕩頻率',
    oscillatorCategory: '振蕩器分類',
    divider: '分頻器',
    voltageRegulator: '電壓調節器',
    cmos: 'C-MOS',
    lvds: 'LVDS',
    lvpecl: 'LVPECL',
    ttl: 'TTL',
    pinElectronics: '引腳電子',
    driver: '驅動器',
    ate: 'ATE',
    test: '測試',
    dutyRatio: '占空比',
    displaySize: '顯示尺寸',
    displaySizeSegments: '顯示段數',
    displaySizeCommons: '顯示公共端數',
    displaySizeLines: '顯示行數',
    displaySizeChannels: '顯示通道數',
    operatingVoltageVdd: '工作電壓VDD',
    operatingVoltageVlcd: '工作電壓VLCD',
    ddramBits: 'DDRAM位數',
    evrSteps: 'EVR步數',
    voltageBooster: '電壓升壓器',
    icon: '圖標',
    lcdCategory: 'LCD分類',
    eightBit: '8位',
    fourBit: '4位',
    serial: '串行',
    parallel: '並行',
    channels: '通道',
    ldType: 'LD類型',
    maxOperatingFrequency: '最大工作頻率',
    driveCurrentLed: 'LED驅動電流',
    driveCurrentOperating: '工作驅動電流',
    driveCurrentThreshold: '閾值驅動電流',
    ledCurrentMinPulseWidth: 'LED電流最小脈寬',
    risingFallingTime: '上升下降時間',
    maxOutputRatePerChannel: '每通道最大輸出速率',
    maxOperatingCurrentLd1: 'LD1最大工作電流',
    maxOperatingCurrentLd2: 'LD2最大工作電流',
    maxOperatingCurrentLd3: 'LD3最大工作電流',
    maxOperatingCurrentLd4: 'LD4最大工作電流',
    aecQ100: 'AEC-Q100',
    protectionCircuit: '保護電路',
    ldCategory: 'LD分類',
    ldCommon: '公共端',
    cathode: '陰極',
    anode: '陽極',
    onStateResistance: '導通電阻',
    analogSwitch: '模擬開關',
    outputPort: '輸出端口',
    operatingVoltageMin: '最小工作電壓',
    operatingVoltageMax: '最大工作電壓',
    operatingVoltageTyp: '典型工作電壓',
    min: 'MIN',
    ledDrive: 'LED驅動',
    status: '狀態',
    compliant: '兼容',
    peripheral: '外圍設備',
    // 菜單分類
    audioICs: '音頻IC',
    videoICs: '視頻IC',
    powerManagementICs: '電源管理IC',
    batteryManagementICs: '電池管理IC',
    switchingDriverICs: '開關驅動IC',
    signalProcessingICs: '信號處理IC',
    interfaceControlICs: '接口與控制IC',
    specialFunctionICs: '特殊功能IC'
  },
  agentBrands: {
    title: '代理品牌',
    subtitle: '我們與多家知名品牌建立了長期穩定的合作關係',
    brands: {
      nisshinbo: 'Nisshinbo Micro Devices Inc.（日清紡微電子）是一家由原新日本無線（JRC）與理光微電子（Ricoh）於 2022 年合併而成的日本半導體公司。專注於運算放大器（Op-Amps）,電源管理IC（LDO穩壓器、DC/DC轉換器）, 音頻處理IC, 感測器模組與模擬前端（AFE）, 電池管理IC, 微波放大器、濾波器及車用ASIC/ASSP等',
      muses: 'MUSES 系列是為高端音頻設備量身打造的旗艦級類比半導體產品線，涵蓋運算放大器、電源管理IC與音量控制器，旨在完美重現「真實原聲」。',
      auk: '可天士AUK（瀋陽中光電子有限公司，KODENSHI SY Corp.）隸屬於 KODENSHI AUK 集團，於1992年8月在瀋陽經濟技術開發區成立，專注於光電器件的研發、生產與銷售，產品涵蓋光電二極管、光電三極管、光電開關、編碼器、紙張傳感器及光電耦合器等，並提供從晶圓製造、IC設計到封裝測試、模組開發及 OEM/ODM 的一站式服務。',
      feihong: '廣州飛虹半導體科技有限公司（FeiHong Semiconductor Technology Co., Ltd.）成立於2002年，總部位於廣州越秀區，是國內領先的IGBT與MOSFET製造商，專注於高功率場效應管和三極管等分立半導體裝置的研發、生產與銷售，產品廣泛應用於家電、LED照明、電源設備、充電器、逆變器、新能源汽車及工業等領域。'
    },
    cooperationTime: '合作時間',
    mainProducts: '主要產品',
    marketCoverage: '市場覆蓋',
    cooperationProcess: '合作流程',
    step1: '初步洽談',
    step1Desc: '了解雙方需求',
    step2: '合作評估',
    step2Desc: '商討合作條件',
    step3: '簽訂協議',
    step3Desc: '確定合作細節',
    step4: '正式合作',
    step4Desc: '開展業務合作',
    contactTitle: '品牌合作諮詢',
    contactDesc: '如果您有意向與我們合作，請填寫以下表單，我們將盡快與您聯繫',
    cooperationIntention: '合作意向',
    submitApplication: '提交申請'
  },
  dealerBrands: {
    title: '經銷品牌',
    subtitle: '我們提供多種優質品牌的經銷服務',
    advantages: '經銷優勢',
    advantage1: '優質貨源',
    advantage1Desc: '與知名品牌直接合作，確保產品質量',
    advantage2: '價格優勢',
    advantage2Desc: '廠家直供，價格優惠，利潤空間大',
    advantage3: '營銷支持',
    advantage3Desc: '提供專業的營銷方案和推廣支持',
    advantage4: '售後服務',
    advantage4Desc: '完善的售後服務體系，解決後顧之憂'
  },
  contact: {
    title: '聯繫我們',
    subtitle: '我們期待與您建立聯繫',
    contactInfo: '聯繫方式',
    companyAddress: '公司地址',
    address: '香港沙田小瀝源安平街6號新貿中心B座10樓07室',
    addressZhongshan: '中山市民眾鎮陽光大道中山保稅物流中心綜合辦公大樓808室',
    contactPhone: '聯繫電話',
    phone1: '(852)2635 2112',
    contactEmail: '電子郵箱',
    email: 'cs@kamzitech.com',
    workingTime: '工作時間',
    weekdays: '週一至週五：9:00 - 17:30',
    onlineMessage: '在線留言',
    companyLocation: '公司位置'
  },
  validation: {
    nameRequired: '請輸入姓名',
    phoneRequired: '請輸入聯繫電話',
    emailRequired: '請輸入郵箱地址',
    emailFormat: '請輸入正確的郵箱地址',
    subjectRequired: '請輸入主題',
    messageRequired: '請輸入留言內容',
    companyRequired: '請輸入公司名稱',
    intentionRequired: '請輸入合作意向'
  },
  message: {
    submitSuccess: '留言提交成功，我們將盡快與您聯繫！',
    submitFailed: '提交失敗，請稍後重試',
    fetchNewsFailed: '獲取新聞失敗',
    fetchModelsFailed: '獲取型號列表失敗',
    fileNotFound: '文件未找到',
    downloadStarted: '下載已開始',
    downloadFailed: '下載失敗'
  },
  footer: {
    aboutUs: '關於我們',
    aboutUsDesc: '金矽科技(香港)有限公司',
    contactInfo: '聯繫方式',
    phone: '電話',
    email: '郵箱',
    address: '地址',
    followUs: '關注我們',
    companyName: '金矽科技(香港)有限公司',
    allRightsReserved: '版權所有',
    whatsappQr: 'WhatsApp二維碼',
    wechatQr: '微信二維碼',
    telegramQr: 'Telegram二維碼',
  }
} 
